import styled from 'styled-components';
import {
  boldHeadLine4,
  galleryImages,
  headLine3,
  headLine4,
  headLine5,
  para1,
} from '../../theme/GlobalStyle';

const AccordionContainer = styled.div`
  h3 {
    margin-bottom: 20px;
    font-size: 24px;
    ${(props) => props.theme.fontStyleBold}
  }
`;

const AccordionList = styled.div`
  border-top: 2px solid #edeef5;
  border-radius: 4px;
  margin: 10px 0;

  .accordion-container {
    border-bottom: 2px solid #edeef5;
  }

  .accordion-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 22px 10px;
    cursor: pointer;
    position: relative;

    /* Sticky header when accordion content is open */
    &.sticky {
      position: sticky;
      top: 0;
      z-index: 1;
    }

    h2 {
      margin-right: 10px;
      font-size: 20px;
      ${(props) => props.theme.fontStyleRegular}
      font-weight: 700;
      text-decoration: underline;
      text-decoration-color: ${(props) => props.theme.color.orangeUnderline};
      text-decoration-thickness: 3px;
      text-underline-offset: 4px;

      @media (max-width: 768px) {
        font-size: 18px;
      }

      &:first-letter {
        text-transform: uppercase;
      }
    }
  }

  .accordion-icon {
    font-size: 18px;

    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  .accordion-content {
    overflow-x: hidden;
    overflow-y: auto;
    max-height: 0;
    transition: max-height 0.3s ease;
    padding: 0 10px;
  }

  .accordion-content.open {
    transition: max-height 0.5s ease;
  }

  .accordion-content p {
    @media (max-width: 768px) {
      font-size: 16px;
    }
  }

  .content {
    padding: 0 0 10px;
    h1,
    h2,
    h3 {
      ${headLine3}
    }
    h4 {
      ${headLine4}
    }
    h5,
    h6 {
      ${headLine5}
    }
    span a img {
      width: 18px;
      display: inline;
      vertical-align: middle;
    }
    p .alignleft {
      float: left;
      margin: 0 15px 0 0;
      width: 300px;
      height: 169px;
    }
    p .alignright {
      float: right;
      margin: 0 0 0 15px;
      width: 300px;
      height: 169px;
    }
    li {
      margin: 10px 0;
    }
    p .alignleft {
      float: left;
      margin: 0 15px 0 0;
      width: 300px;
      height: 169px;
    }
    p .alignright {
      float: right;
      margin: 0 0 0 15px;
      width: 300px;
      height: 169px;
    }
    p iframe {
      width: 100%;
    }
    ul,
    ol {
      margin: 20px 0 20px 5px;
      padding-left: 15px;
    }
    ul,
    ol,
    p {
      ${para1}
      color: ${(props) => props.theme.color.textLight};
    }
    ul {
      list-style-type: disc;
      strong,
      b {
        ${boldHeadLine4}
      }
    }
    .grid-images {
      display: flex;
      flex-wrap: wrap;
      gap: 30px;

      & img {
        width: 22%;
        object-fit: contain;
      }

      @media (max-width: 1210px) {
        & img {
          width: 30%;
        }
      }

      @media (max-width: 768px) {
        & img {
          width: 44%;
        }
      }
    }

    p {
      margin: 15px 0;
      ${para1}
      color: ${(props) => props.theme.color.textLight};

      strong,
      b {
        ${boldHeadLine4}
      }
    }
    a {
      color: ${(props) => props.theme.color.primary};
      ${para1}
      text-decoration: underline;
    }
    a.blue {
      color: ${(props) => props.theme.color.primary};
      ${para1}
      text-decoration: underline;
    }
    a.white {
      color: ${(props) => props.theme.color.white};
      ${para1}
      text-decoration: underline;
    }
    video {
      width: 100%;
      height: auto;
    }
    .wp-video {
      width: 100% !important;
    }

    table {
      text-align: center;
      td {
        vertical-align: top;
        padding: 10px;
        strong,
        b {
          ${boldHeadLine4}
        }
      }
    }
    blockquote {
      padding: 30px 50px;
      margin: 15px 0;
      background-color: ${(props) => props.theme.color.bgPrimary};
      color: ${(props) => props.theme.color.white};
      p {
        color: ${(props) => props.theme.color.white};
        ${para1}
      }
      a {
        color: ${(props) => props.theme.color.white};
        ${para1}
        transition: text-decoration ease-in-out 0.2s;

        @media (min-width: 1024px) {
          &:hover {
            text-decoration: underline;
          }
        }
      }
      span {
        position: relative;
        color: ${(props) => props.theme.color.white};
        ${para1}
        &:before {
          content: '"';
          position: absolute;
          left: -20px;
          font-size: 40px;
        }
        &:after {
          content: '"';
          position: absolute;
          right: -20px;
          font-size: 40px;
        }
      }
    }
    .inline-twitter-link,
    .bctt-ctt-text a {
      color: #333333;
      background-color: #d9ecfd;
      text-decoration: none;
      transition: all ease-in-out 0.2s;

      @media (min-width: 1024px) {
        &:hover {
          background-color: #337ab7;
          color: #fff;
          text-decoration: underline;
        }
      }
    }
    @media (max-width: 995px) {
      blockquote {
        padding: 25px 50px;
      }
    }
    ${galleryImages}
  }
`;

export { AccordionContainer, AccordionList };
